import { FC } from 'react';
import { Button, Flex, Result } from 'antd';

import { PageWrapper } from 'components/ui';

const MeetingsLogs: FC = () => {
  return (
    <PageWrapper title="Meeting logs" color="white">
      <Flex justify="center">
        <Result
          status="404"
          title="Logs Have Moved"
          style={{ maxWidth: 500 }}
          subTitle="Call and connection logs are no longer available in the admin panel. You can now access all logs directly from the Twilio Console."
          extra={
            <Button
              type="primary"
              href="https://console.twilio.com/us1/monitor/insights/video/video-rooms"
              target="_blank"
              rel="noreferrer"
            >
              Open Twilio Console
            </Button>
          }
        />
      </Flex>
    </PageWrapper>
  );
};

export default MeetingsLogs;
